export default "__VITE_ASSET__a1facad1__"